import { createAsyncThunk } from '@reduxjs/toolkit';
import { setHumanizing, setHumanizingDone } from '.';
import { snackAdded } from '../system';

export const startHumanization = createAsyncThunk(
    'humanize/startHumanization',
    async (_, { dispatch }) => {
        dispatch(setHumanizing(true));
    }
);

export const endHumanization = createAsyncThunk(
    'humanize/endHumanization',
    async (success: boolean, { dispatch }) => {
        dispatch(setHumanizing(false));
        dispatch(setHumanizingDone(true));
        if (success) {
            dispatch(snackAdded({
                message: "Content humanized successfully!",
                type: "success",
                duration: 2000,
            }));
        }
    }
);